/**
 * 登录名策略（与后端 LoginIdPolicyService / PasswordConstants 一致）。
 */

export const LOGIN_ID_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]{3,29}$/;

export const LOGIN_ID_RULE_HINT =
    '须以字母开头，仅含字母、数字、下划线，长度 4–30，不可使用系统保留名';

const RESERVED_LOGIN_IDS = new Set([
    'sysadmin',
    'admin',
    'root',
    'system',
    'test',
    'guest',
    'operator',
    'superadmin',
]);

/**
 * @param {string} loginId
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateLoginId(loginId) {
    if (!loginId || !String(loginId).trim()) {
        return { valid: false, message: '请输入登录名' };
    }
    const id = String(loginId).trim();
    if (!LOGIN_ID_PATTERN.test(id)) {
        return { valid: false, message: LOGIN_ID_RULE_HINT };
    }
    if (RESERVED_LOGIN_IDS.has(id.toLowerCase())) {
        return { valid: false, message: '该登录名为系统保留，不可使用' };
    }
    return { valid: true };
}

/** Ant Design Form 校验器 */
export function loginIdFormValidator() {
    return (_, value) => {
        if (!value || !String(value).trim()) {
            return Promise.reject(new Error('请输入登录名'));
        }
        const result = validateLoginId(value);
        if (!result.valid) {
            return Promise.reject(new Error(result.message));
        }
        return Promise.resolve();
    };
}
